import { useFloatingPortalNode } from '@floating-ui/react';
import { createPortal } from 'react-dom';

const FloatingPortal = () => {
    const portalNode = useFloatingPortalNode({
        // Accepts `id` and `root` props
    });

    if (portalNode) {
        return createPortal(<div />, portalNode);
    }

    return null;
};

export default FloatingPortal;
